var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3Rdretailicons9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.79 15.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 7.89,
    cy: 7.89,
    r: 7.89,
    style: {
      fill: "#1e3f76",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.93,12.54A2.19,2.19,0,0,1,13,9.25H9.89V9.12a1.11,1.11,0,0,0-1.09-1H8.71a.37.37,0,1,0,0,.74h.08a.36.36,0,0,1,.36.32l.51,4.28a1.82,1.82,0,0,0,1.81,1.62h3.82a.37.37,0,1,0,0-.74H11.47a1.09,1.09,0,0,1-1-.73H14.8a1.82,1.82,0,0,0,1.8-1.5l.09-.49A2.19,2.19,0,0,1,14.93,12.54Z",
    transform: "translate(-4.64 -4.61)",
    style: {
      fill: "#171c32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.26,
    cy: 11.6,
    r: 0.73,
    style: {
      fill: "#171c32"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.92,
    cy: 11.6,
    r: 0.73,
    style: {
      fill: "#171c32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.83,10.71h.73v.74a.37.37,0,0,0,.37.36.36.36,0,0,0,.36-.36v-.74H16a.36.36,0,0,0,.37-.36A.37.37,0,0,0,16,10h-.73V9.25a.36.36,0,0,0-.36-.36.37.37,0,0,0-.37.36V10h-.73a.38.38,0,0,0-.37.37A.37.37,0,0,0,13.83,10.71Z",
    transform: "translate(-4.64 -4.61)",
    style: {
      fill: "#171c32"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Rdretailicons9);
export default __webpack_public_path__ + "static/media/3rdretailicons9.84e7869621de762a4d2307f8237ddda3.svg";
export { ForwardRef as ReactComponent };